module.exports = __webpack_public_path__ + "static/media/closet.ef0bd007.jpeg";